export const LOGIN = "LOGIN";
export const GetToken = () => {
  const token = JSON.parse(localStorage.getItem(LOGIN));
  return token?.idToken ?? false;
};
